import PropTypes from 'prop-types';

const ContactGroupPropType = PropTypes.shape( {
	id: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	emails: PropTypes.arrayOf( PropTypes.string ).isRequired
} );

export default ContactGroupPropType;
